// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  
  .modal-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .modal-content {
    background: white;
    padding: 2rem;
    border-radius: 10px;
    max-width: 500px;
    width: 100%;
  }
  
  .modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .modal-buttons button {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .modal-buttons button:first-child {
    background-color: #4CAF50; /* Green */
    color: white;
  }
  
  .modal-buttons button:first-child:hover {
    background-color: #45a049;
  }
  
  .modal-buttons button:last-child {
    background-color: #f44336; /* Red */
    color: white;
  }
  
  .modal-buttons button:last-child:hover {
    background-color: #d32f2f;
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/components/Modals/Modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB,EAAE,UAAU;IACrC,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB,EAAE,QAAQ;IACnC,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".modal-container {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .modal-overlay {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n  }\r\n  \r\n  .modal-content {\r\n    background: white;\r\n    padding: 2rem;\r\n    border-radius: 10px;\r\n    max-width: 500px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .modal-buttons {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 1rem;\r\n    margin-top: 1rem;\r\n  }\r\n  \r\n  .modal-buttons button {\r\n    padding: 0.75rem 1.5rem;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .modal-buttons button:first-child {\r\n    background-color: #4CAF50; /* Green */\r\n    color: white;\r\n  }\r\n  \r\n  .modal-buttons button:first-child:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .modal-buttons button:last-child {\r\n    background-color: #f44336; /* Red */\r\n    color: white;\r\n  }\r\n  \r\n  .modal-buttons button:last-child:hover {\r\n    background-color: #d32f2f;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
